export const TEAM_COLLECTION = 'teams'
export const EVENT_COLLECTION = 'events'
export const RUNDOWN_COLLECTION = 'rundowns'
export const CUE_COLLECTION = 'cues'
export const COLUMN_COLLECTION = 'columns'
export const CELL_COLLECTION = 'cells'
export const MENTION_COLLECTION = 'mentions'
export const RUNNER_COLLECTION = 'runners'
export const CODE_COLLECTION = 'codes'
export const TXN_COLLECTION = 'paddle-txns'
export const SUB_COLLECTION = 'paddle-subs'
export const PRODUCT_COLLECTION = 'paddle-products'
export const PROMPTER_COLLECTION = 'prompters'
export const HISTORY_COLLECTION = 'history'
export const API_TOKEN_COLLECTION = 'api-tokens'
